import { render } from "./ModalRRIM.vue?vue&type=template&id=5581eb23&scoped=true"
import script from "./ModalRRIM.vue?vue&type=script&lang=js"
export * from "./ModalRRIM.vue?vue&type=script&lang=js"

import "./ModalRRIM.vue?vue&type=style&index=0&id=5581eb23&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5581eb23"]])

export default __exports__